import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-ump-loading-overlay',
    templateUrl: './ump-loading-overlay.component.html',
    styleUrls: ['./ump-loading-overlay.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UmpLoadingOverlayComponent {
    constructor() { }
}
